<bv-dialog-title>{{ "FEATURE_REQUIRES_PAID_PLAN" | translate }}</bv-dialog-title>
<bv-dialog-body class="full-width text-center">
  <div class="pad-bottom">
    {{ "MAX_PLAYERS_YOUR_PLAN" | translate }}:
    <span class="tc-bv-orange">{{ clubServ.getPlayerLimit() }}</span>
  </div>
</bv-dialog-body>
<bv-dialog-footer>
  <button bv-button variant="ghost" (click)="dialogRef.close()">{{ "CLOSE" | translate }}</button>
  <button
    id="btn_go_subscription"
    bv-button variant="primary"
    (click)="goSubscription()"
  >
    {{ "COMPARE_PLANS" | translate }}
  </button>
</bv-dialog-footer>
